import { isEmpty, set } from 'lodash'
import { defaultExportMenu, getBubbleSeries } from '../helpers'

export default ({ config, data, color, legendLabels }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    xKey,
    disabledScrollabarX = false,
    disabledScrollabarY = false,
    removeLegend,
    labelsRotation,
    xTitle,
    yTitle,
    disabledAnimations = false,
    xMin,
    xMax,
    xStrictMinMax = false,
    yMin,
    yMax,
    exportingMenu,
    yStrictMinMax = false
  } = restConfig

  const keys = []
  if (!isEmpty(series)) {
    series.forEach((el) => {
      // get custom legend labels with translated values
      !isEmpty(legendLabels) &&
        Object.keys(legendLabels).forEach((key) => {
          if (el.includes(key)) {
            keys.push(legendLabels[key])
          }
        })
    })
  }

  const configuration = {
    type: 'XYChart',
    data,
    series: getBubbleSeries({
      series,
      otherConfig: {
        legendLabel: keys,
        color,
        labelColor,
        disabledAnimations,
        ...restConfig
      }
    }),
    xAxes: [
      {
        type: 'ValueAxis',
        dataFields: {
          category: xKey
        },
        title: {
          text: xTitle,
          fill: labelColor
        },
        min: xMin,
        max: xMax,
        strictMinMax: xStrictMinMax,
        renderer: {
          labels: {
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.7,
          maxLabelPosition: 0.98
        }
      }
    ],
    yAxes: [
      {
        type: 'ValueAxis',
        title: {
          text: yTitle,
          fill: labelColor
        },
        min: yMin,
        max: yMax,
        strictMinMax: yStrictMinMax,
        renderer: {
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          labels: {
            fill: labelColor
          }
        }
      }
    ],
    scrollbarX: {
      disabled: disabledScrollabarX,
      parent: 'bottomAxesContainer'
    },
    scrollbarY: {
      type: 'Scrollbar',
      disabled: disabledScrollabarY
    },
    cursor: {},
    legend: {
      useDefaultMarker: true,
      labels: {
        text: '{name}',
        fill: labelColor
      },
      contentAlign: 'left',
      paddingTop: 10,
      paddingLeft: 45,
      markers: {
        children: [
          {
            width: 20,
            height: 20,
            fontSize: 200,
            strokeWidth: 0,
            paddingTop: 2.5,
            marginLeft: 22.5,
            paddingLeft: 2.5,
            strokeOpacity: 0,
            paddingRight: 2.5,
            paddingBottom: 2.5,
            cornerRadiusTopLeft: 0,
            cornerRadiusTopRight: 0,
            cornerRadiusBottomLeft: 0,
            cornerRadiusBottomRight: 0
          }
        ]
      }
    }
  }
  if (removeLegend) {
    delete configuration.legend
  }

  if (labelsRotation && labelsRotation !== 0) {
    set(configuration.xAxes[0], 'renderer.labels.horizontalAlignment', 'middle')
  } else {
    set(configuration.xAxes[0], 'renderer.labels.horizontalCenter', 'right')
    set(configuration.xAxes[0], 'renderer.labels.verticalCenter', 'left')
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      configuration.exporting = defaultExportMenu
    } else {
      configuration.exporting = exportingMenu.config
    }
  }
  return configuration
}
